import styled, { css } from "styled-components"
export const PrinterCardContainer = styled.div`
display: flex;
padding: 16px;
flex-direction: column;
align-items: flex-start;
gap: 16px;
width: 100%;
background-color: #f1f4f7;
min-height: 100vh;
`
export const PrinterCard = styled.div`
display: flex;
width: 100%;
padding: 12px;
align-items: flex-start;
gap: 16px;
border-radius: 4px;
background: var(--Neutral-White, #FEFEFE);
cursor: pointer;
`

export const PrinterCardContent = styled.div`
display: flex;
flex-direction: column;
align-items: flex-start;
gap: 8px;
flex: 1 0 0;
width: 100%;
`
export const PrinterCardHeader = styled.div`
display: flex;
padding: 4px 0px;
justify-content: space-between;
align-items: center;
align-self: stretch;
& p {
    color: var(--Secondary-Dark-1, #0C202A);
font-family: Inter;
font-size: 16px;
font-style: normal;
font-weight: 600;
line-height: 24px; /* 150% */
}
`
export const PrinterCardBody = styled.div`
display: flex;
flex-direction: column;
justify-content: center;
align-items: flex-start;
gap: 4px;
align-self: stretch;
border-radius: 4px;
background: var(--Primary-Light-Alabaster-1, #F5F5F5);
width: 100%;
`

export const PrinterCardBodyDetails = styled.div`
display: flex;
padding: 8px;
align-items: center;
gap: 8px;
align-self: stretch;
color: var(--Secondary-Smokey-Grey-1, #6B7270);
font-family: Inter;
font-size: 12px;
font-style: normal;
font-weight: 500;
line-height: 24px; /* 200% */
word-break: break-word;
`

export const TabGroup = styled.div`
display: flex;
padding: 8px 16px;
align-items: flex-start;
gap: 8px;
align-self: stretch;
border-bottom: 1px solid var(--Secondary-Light-Grey-1, #DFDFDF);
background: var(--Neutral-White, #FEFEFE);
overflow-x: scroll;
overflow-y: hidden;
&.w-150 {
    width: 750px;
}
@media (min-width: 768px) {
    padding-top: 16px;
    &.w-150 {
        width: 100%;
    }

    overflow: hidden!important;
}

&.menus {
    background: transparent;
    border: none;
    padding: 16px 16px 0px 16px;

    &.menus-header {
        padding-left: 0px;
        @media (max-width: 576px) {
            padding: 0px;
            .menus-header-button {
                padding: 8px 16px!important;
                flex: 0 0 auto!important;
            }
        }
        & > div[class*="TabItem"] {
            border: 1px solid var(--Secondary-Light-Grey-1, #DFDFDF);
            background: #FEFEFE;
             @media (max-width: 576px) { 
             flex: 1;
             padding: 8px 4px;
             font-size: 12px;
             text-overflow: unset;
            }
        }

       
    }
    &.options-set-header {
        @media (max-width: 767px) {
            display: grid;
            grid-template-columns: 1fr 1fr 1fr;
            gap: 6px;
             & > div[class*="TabItem"] {
                width: 100%;
                font-size: 11px;
               
             }
            &-2 {
                grid-template-columns: 1fr 1fr;
            }
        }
    }

    & > div[class*="TabItem"] {
        flex: 0 0 auto;
        padding: 8px 16px;
        &.long-text {
            padding: 7px 9px;
        }

        @media (max-width: 767px) {
        &.mobile-button {
           font-size: 12px !important;
        }
    }
    }
    @media (min-width: 768px) {
        &.menus-end {
            justify-content: flex-end;
        }
    }
    
    
}

&.flex-col-mobile {
    @media (max-width: 576px) {
    flex-direction: column;
    align-items: stretch;
    }
}
    

`
export const TabItem = styled('div')<{ active?: boolean}>`
display: flex;
padding: 8px;
justify-content: center;
align-items: flex-start;
gap: 4px;
border-radius: 4px;
background: var(--Neutral-Gray, #F1F4F7);
color: var(--Secondary-Smokey-Grey-1, #6B7270);
text-align: center;
font-family: Inter;
font-size: 14px;
font-style: normal;
font-weight: 600;
line-height: 24px; /* 200% */
display: -webkit-box;
-webkit-line-clamp: 1;
-webkit-box-orient: vertical;
overflow: hidden;
text-overflow: ellipsis;
cursor: pointer;

&.flex-unset-desktop {
    flex: 1;
}

&:hover {
    background: var(--Primary-Red-Orange-1, #FB2F2F)!important;
    color: var(--Neutral-White, #FEFEFE);
}

${ props => props.active ?  css`
background: var(--Primary-Red-Orange-1, #FB2F2F)!important;
color: var(--Neutral-White, #FEFEFE);
`
: null}

@media (min-width: 768px) {
    flex: 1;

    &.flex-unset-desktop {
        flex: unset;
        padding: 8px 24px;

        &.w-108 {
            width: 108px;
        }
    }
}
@media (max-width: 768px) {
       &.mobile_menu {
        font-size: 12px !important;
        white-space: nowrap;
        padding: 6px !important;
        }
        &.long-button {
        padding: 6px !important;
        flex: 2 !important;
        font-size: 11px !important;
    }
}
@media (max-width: 505px) {
    &.footer-button{
            -webkit-line-clamp: 2;
            height: 64px;
            align-items:center;
        }
    &.long-button {
        flex: 3 !important;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
    }
}

@media (max-width: 466px) {
       &.mobile_menu {
        font-size: 9px !important;
        line-height: 16px;
        white-space: nowrap;
        padding: 6px !important;
        }
        &.long-button {
            padding: 6px 0px !important;
            font-size: 8px !important;
            flex: 4 !important;
            line-height: 16px;
        }
}
    
`
